import winManager from "@/services/book_win";
import VueInst from "@/main_app.js";
import { getBookbyId as getBookbyId } from "@/store/modules/books.js";
import store from "@/store/store";

export default {
  handleKeydown,
  loadShortcutsFromSettings,
  addShortcutToSettings,
  removeShortcutFromSettings,
  editShortcutInSettings,
  checkIfShortcutExists,
  getShortcutsList,
  cleanCode,
  getCharacterByLanguage,
  getCharacterRealCode,
};
let shortcuts = {};
export function loadShortcutsFromSettings(us) {
  try {
    if (us) {
      shortcuts = us;
    } else shortcuts = {};
  } catch (error) {
    console.error("שגיאה בטעינת הקיצורים:", error);
  }
}

function addShortcutToSettings(key, action) {
  try {
    let currentSetting = VueInst.userSettings.settings.shortcuts;
    if (!currentSetting) currentSetting = {};
    else currentSetting = JSON.parse(currentSetting);

    currentSetting[key] = action;

    VueInst.userSettings.setSettings(
      "shortcuts",
      JSON.stringify(currentSetting)
    );
    shortcuts[key] = action;
    return true;
  } catch (error) {
    console.error("שגיאה בהוספת קיצור:", error);
    return false;
  }
}
function editShortcutInSettings(oldKey, newKey) {
  try {
    let currentSetting = VueInst.userSettings.settings.shortcuts;
    if (shortcuts.hasOwnProperty(oldKey) && currentSetting) {
      if (shortcuts.hasOwnProperty(newKey)) {
        currentSetting = JSON.parse(currentSetting);
        currentSetting[newKey] = currentSetting[oldKey];
        delete currentSetting[oldKey];
      } else {
        currentSetting = currentSetting.replace(oldKey, newKey);
        currentSetting = JSON.parse(currentSetting);
      }
      VueInst.userSettings.setSettings(
        "shortcuts",
        JSON.stringify(currentSetting)
      );
      shortcuts = currentSetting;
      return true;
    }
    return false;
  } catch (error) {
    console.error("שגיאה בעריכת קיצור:", error);
    return false;
  }
}

function removeShortcutFromSettings(key) {
  try {
    let currentSetting = VueInst.userSettings.settings.shortcuts;
    if (!currentSetting) return false;
    currentSetting = JSON.parse(currentSetting);
    delete currentSetting[key];

    VueInst.userSettings.setSettings(
      "shortcuts",
      JSON.stringify(currentSetting)
    );
    delete shortcuts[key];
    return true;
  } catch (error) {
    console.error("שגיאה במחיקת קיצור:", error);
    return false;
  }
}

function checkIfShortcutExists(key) {
  try {
    return shortcuts[key] ? true : false;
  } catch (error) {
    console.error("שגיאה בעת בדיקה האם קיים קיצור דרך:", error);
    return false;
  }
}
function getShortcutsList() {
  let shorts = Object.entries(shortcuts).map(([keys, book]) => {
    let b = getBookbyId(book);
    let realchar = keys.replace("alt", "");
    return {
      char: getCharacterByLanguage(realchar),
      realChar: realchar,
      short: "Alt",
      book: b,
    };
  });
  return shorts;
}
function cleanCode(input) {
  return input.replace(/Key|Digit|Numpad/g, "");
}
function handleKeydown(event) {
  if (event.altKey) {
    const key = "alt" + cleanCode(event.code);
    if (shortcuts[key]) {
      const bookToOpen = shortcuts[key];
      if (bookToOpen) {
        event.preventDefault();
        event.stopPropagation();
        executeAction("OpenBook", bookToOpen);
      }
    }
  }
  // if (event.ctrlKey) {
  //   const key = "ctrl" + event.code.replace("Key", "");
  //   if (shortcuts[key]) {
  //   }
  // }
  // if (event.shiftKey) {
  //   const key = "shift" + event.code.replace("Key", "");
  //   if (shortcuts[key]) {
  //   }
  // }
}
function executeAction(action, data) {
  if (action == "OpenBook") {
    OpenBookShortcut(data);
  } else {
    VueInst.$notify(`פעולה: ${action}`);
  }
}
async function OpenBookShortcut(book) {
  if (book) {
    let openBooks = store.getters["tabsManager/getOpenBooks"];
    for (let tabId of openBooks) {
      let b = parseInt(store.getters[`tabs/${tabId}/getBook`]);
      if (b == book) {
        store.state.tabsManager.maximizeTabBook = tabId;
        return;
      }
    }
    let success = await winManager.createWinBook(book, -1);
    if (!success) {
      VueInst.$notify({
        type: "error",
        message: this.$t("book1.notExistBook"),
        timeout: 2000,
      });
    }
  } else VueInst.$notify(this.$t("book1.enterNumBook"));
}

function getCharacterByLanguage(code) {
  code = code.toUpperCase();
  if (VueInst.userSettings.settings.language == "he")
    return hebrewMap[code] || code;
  else return code;
}
function getCharacterRealCode(char) {
  return hebrewToEnglishMap[char] || char.toUpperCase();
}

const hebrewMap = {
  A: "ש",
  B: "נ",
  C: "ב",
  D: "ג",
  E: "ק",
  F: "כ",
  G: "ע",
  H: "י",
  I: "ן",
  J: "ח",
  K: "ל",
  L: "ך",
  M: "צ",
  N: "מ",
  O: "ם",
  P: "פ",
  Q: "/",
  R: "ר",
  S: "ד",
  T: "א",
  U: "ו",
  V: "ה",
  W: "'",
  X: "ס",
  Y: "ט",
  Z: "ז",
  COMMA: "ת",
  PERIOD: "ץ",
  SEMICOLON: "ף",
};
const hebrewToEnglishMap = {
  א: "T",
  ב: "C",
  ג: "D",
  ד: "S",
  ה: "V",
  ו: "U",
  ז: "Z",
  ח: "J",
  ט: "Y",
  י: "H",
  כ: "F",
  ל: "K",
  מ: "N",
  נ: "B",
  ס: "X",
  ע: "G",
  פ: "P",
  צ: "M",
  ק: "E",
  ר: "R",
  ש: "A",
  ת: "Comma",
  ך: "L",
  ם: "O",
  ן: "I",
  ף: "Semicolon",
  ץ: "Period",
};
